<template>
  <v-container fluid class="mt-3 mt-5 pr-8">
    <p v-if="!organizationSet" class="text-h8 font-weight-light text-uppercase text-center">{{ $t('homeMessage') }}</p>
  </v-container>
</template>

<script>
export default {
  name: "Home",
  components: {},
  mounted() {
     //this.login()
  },
  computed: {
    organizationSet() {
      return this.$store.getters.organizationSet;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
  },
  methods: {
  /* login() {
      if(this.$config.AuthConfigType == 'AD' && !this.isLoggedIn) {
        this.$store.dispatch('login', {user: {}, authType: this.$config.AuthConfigType})
        .then(() => {
        })
        .catch(err => {
          this.message = err
          console.log(err)
        })
      }
    },*/
  }
};
</script>
